export const API_URL = "https://port-0-react-mangoshop-server-6g2llfg440fy.sel3.cloudtype.app"
